module.exports = __webpack_public_path__ + "static/media/ai1-bg.0dba7e9e.jpg";